import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './AccreditationRequestCard.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import { Collapse, Row, Col, Badge } from 'reactstrap';
import moment from 'moment';

class AccreditationRequestCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpenAdditionalTitles: false
        }
    }

    render() {
        if (!_.isNil(this.props.data)) {
            return (
                <div className="accreditation-request-card-container">
                    <IconContainer className="accreditation-request-card-icon" icon="certify" />
                    {this.renderContent()}
                </div>
            );
        } else {
            return null;
        }
    }

    renderContent = () => {
        return (
            <div className="accreditation-request-card-information-container">
                <h5>
                    <Badge color="warning">{_.get(this.props.translation, 'consents.verified_by_applicant_only_label')}</Badge>
                </h5>
                <div className="accreditation-request-card-original-title-container">
                    <h6 onClick={this.toggle}>{this.props.data.accreditationData.titles.original}</h6>
                    {this.renderCollapseArrow()}
                </div>
                <div className="accreditation-request-card-additional-titles-container">
                    <Collapse isOpen={this.state.isOpenAdditionalTitles}>
                        {this.renderAdditionalTitles()}
                    </Collapse>
                </div>
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "orgs.org_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {this.props.data.orgName + ", " + this.props.data.orgDomain}
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "consents.issued_at_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {moment(this.props.data.accreditationData.issuedAt).format("L")}
                    </Col>
                </Row>
                <Row>
                    <Col sm={3}>
                        {_.get(this.props.translation, "accreditation.level_label") + ":"}
                    </Col>
                    <Col sm={9}>
                        {_.get(this.props.translation, 'levels.' + this.props.data.accreditationData.level)}
                    </Col>
                </Row>
            </div>
        )
    };

    renderCollapseArrow = () => {
        let iconName = "keyboard_arrow_" + (this.state.isOpenAdditionalTitles ? "down" : "right");
        return (
            <IconContainer onClick={this.toggle} className="accreditation-request-card-additional-titles-icon" icon={iconName} />
        )
    };

    renderAdditionalTitles = () => {
        let result = [];
        _.mapValues(this.props.data.accreditationData.titles, (value, key) => {
            if (key !== "original"){
                result.push(
                    <Row key={key}>
                        <Col sm={2}>
                            {"(" + _.get(this.props.translation, 'langs.' + key) + ")"}
                        </Col>
                        <Col sm={10}>
                            {value}
                        </Col>
                    </Row>
                );
            }
        });
        return result;
    };

    toggle = () => {
        this.setState({ isOpenAdditionalTitles: !this.state.isOpenAdditionalTitles });
    }
}

AccreditationRequestCard.propTypes = {
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
};

export default AccreditationRequestCard;



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/accreditationRequestCard/AccreditationRequestCard.js